import { FC } from 'react';

import sizes from 'constants/sizes';

import { CanjeModalProvider } from './context/CanjeModalContext';
import CanjeModal from './index';

type Props = {
  /** Usado por App.js para el tamaño del diálogo Bootstrap */
  size?: string;
};

const CanjeModalWithProvider: FC<Props> = ({ size = sizes.LG }) => (
  <CanjeModalProvider size={size}>
    <CanjeModal />
  </CanjeModalProvider>
);

export default CanjeModalWithProvider;
